module.exports = __webpack_public_path__ + "static/img/read-empty.90d5025a.png";